import { render, staticRenderFns } from "./HistorizationOption.vue?vue&type=template&id=72baf309&"
import script from "./HistorizationOption.vue?vue&type=script&lang=js&"
export * from "./HistorizationOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports